// eslint-disable-next-line no-unused-vars
const style = require('./src/components/css/themes.css');
const { scheduleFontLoad } = require('./src/services/fonts/loadFonts');

exports.shouldUpdateScroll = ({ routerProps: { location }, prevRouterProps }) => {
  // If navigating to a new page (not just hash change), scroll to top
  if (prevRouterProps && location.pathname !== prevRouterProps.location.pathname) {
    window.scrollTo(0, 0);
    return false;
  }
  // For hash links, let the browser handle it
  if (location.hash) {
    return location.hash;
  }
  return true;
};

exports.onClientEntry = () => {
  if (typeof window === 'undefined') {
    return;
  }

  const currentPath = window.location.pathname;
  if (currentPath === '/' || currentPath === '/index.html') {
    scheduleFontLoad();
  }

  if (
    !window.location.pathname.includes('/flight/') &&
    !window.location.pathname.includes('/flight_dev/') &&
    !window.location.pathname.includes('/flight_feedback/') &&
    !window.location.pathname.includes('/airport_report/') &&
    !window.location.pathname.includes('/flight_report/') &&
    !window.location.pathname.includes('/app_report/')
  )
    return;
  const langs = [`es`, `de`, `fr`, `ja`, `ko`, `ru`];
  const userLang = navigator.language.substr(0, 2);
  let detectedLang;
  let isLangLink = false;
  let linkLang = '';

  langs.forEach((lang) => {
    if (userLang === lang) {
      detectedLang = lang;
    }
    if (window.location.pathname.startsWith(`/${lang}/`)) {
      isLangLink = true;
      linkLang = lang;
    }
  });

  let path;
  if (isLangLink) {
    if (detectedLang) {
      path = window.location.pathname.replace(linkLang, detectedLang);
    } else {
      window.location.pathname = window.location.pathname.replace(linkLang + '/', '');
    }
  } else {
    path = `/${detectedLang}${window.location.pathname}`;
  }

  if (detectedLang && detectedLang !== linkLang) window.location.pathname = path;
};
